export default "__VITE_ASSET__BoN9Di3e__"